// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { CollapseTokens } from './type';

const collapseTokens: CollapseTokens = {
  collapseIconColor: 'Neutral-text-4',
  collapseIconHoverBackgroundColor: 'Neutral-fill-2',
  collapseIconActiveBackgroundColor: 'Neutral-fill-3',
  collapseExtraMargin: 'Spacing-24',
  collapseWrapperBorderSize: 'Border-1',
  collapseWrapperBorderRadius: 'Radius-default',
  collapseWrapperBorderColor: 'Neutral-border-1',
  collapseWrapperGap: 'Size-12',
  collapseWrapperPaddingX: 'Spacing-16',
  collapseWrapperPaddingY: 'Spacing-12',
  collapseWrapperColor: 'Neutral-border-1',
  collapseWrapperBackgroundColor: 'Neutral-fill-1',
  collapseHeaderBorderColor: 'Neutral-border-1',
  collapseHeaderLineHeight: 'Size-11',
  collapseHeaderGap: 'Spacing-8',
  collapseHeaderFontSize: 'Font-14',
  collapseHeaderFontWeight: 'Weight-regular',
  collapseHeaderIconWidth: 'Size-7',
  collapseHeaderExtraGap: 'Size-5',
  collapseHeaderColor: 'Neutral-text-5',
  collapseContentLineHeight: 'Size-11',
  collapseContentGap: 'Spacing-24',
  collapseContentPaddingY: 'Spacing-12',
  collapseContentPaddingLeft: 'Spacing-38',
  collapseContentPaddingRight: 'Spacing-16',
  collapseContentFontSize: 'Font-14',
  collapseContentFontWeight: 'Weight-regular',
  collapseContentColor: 'Neutral-text-4',
  collapseContentBackgroundColor: 'Neutral-fill-2',
  collapseDisabledColor: 'Neutral-text-2',
};

export default collapseTokens;
